import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=534eae86&scoped=true"
import script from "./couponList.vue?vue&type=script&lang=js"
export * from "./couponList.vue?vue&type=script&lang=js"
import style0 from "./couponList.vue?vue&type=style&index=0&id=534eae86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534eae86",
  null
  
)

export default component.exports